import React from "react";
import { PatternlibTextlink } from "@liebherr/patternlib-react";
import { useTranslation } from "react-i18next";
import Separator from "../separator/Separator";

const NotRightProductDiv = ({ question, support }) => {
  const { t, i18n } = useTranslation();

  const handleClick = () => {
    window.open(`${window.location.origin}/contact`, "_blank");
  };

  return (
    <div>
      <span>{question}</span>
      <PatternlibTextlink
        onClick={handleClick}
        label={support}
        uppercase="false"
      />
      <Separator space="s"></Separator>
      <span>{t("NotRightProductDiv.support3")}</span>
      <PatternlibTextlink
        label={t("contact.websiteContact")}
        uppercase="false"
        icon-position="left"
        href={t("contact.contactUrl")}
      ></PatternlibTextlink>
    </div>
  );
};

export default NotRightProductDiv;
